package org.hs_soft.runmynesto.domain.model.menu

data class MenuFooterModel(
    val id:String,
    val settingIcon:String,
    val exitlloIcon:String,
    val settingTitle:String,
    val companyName:String,
    val userName:String,
)